import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import { Col, Row, Card, Badge, Breadcrumb, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import Generate_payslip from '../../modalPopup/Generate_payslip';
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { Avatar } from 'primereact/avatar';
import noUserImg from "../../assets/images/no_user.png";
import { Sidebar } from 'primereact/sidebar';
import logoImage from '../../assets/images/logo.png';
import stampImage from '../../assets/images/stamp.jpg';
import GifLoder from '../../components/GifLoder';
import { useDebounce } from "use-debounce";
import EditSalarySlip from '../../modalPopup/EditSalarySlip';
import SalaryStatus from '../../modalPopup/SalaryStatus';
import { toWords } from "number-to-words";
const Employee_salary_list = () => {
    const { accessToken, userId, role } = useAuth();
    const [visibleRight, setVisibleRight] = useState(false);
    const [visible, setVisible] = useState(false);
    const [visibleedit, setVisibleedit] = useState(false);
    const [visiblesend, setVisiblesend] = useState(false);
    const [editslip, setEditslip] = useState(null);

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [date, setDate] = useState(null);
    const [selectedpayslip, setSelectedpayslip] = useState(null);


    const lossOfPayDays = selectedpayslip
        ? (selectedpayslip.absentDays ?? 0)
        - (selectedpayslip.adjustmentLeave ?? 0)
        - (selectedpayslip.paidLeaveUsed ?? 0)
        : 0;

    const leaveDeduction = selectedpayslip
        ? Math.round(
            ((selectedpayslip.grossSalary ?? 0) * lossOfPayDays) /
            (selectedpayslip.totalWorkingDays || 1)
        )
        : 0;


    const salaryAfterLeave = selectedpayslip
        ? (selectedpayslip.grossSalary ?? 0) - leaveDeduction
        : 0;

    const totalSalaryPaid = selectedpayslip
        ? salaryAfterLeave
        + (selectedpayslip.overtime ?? 0)
        + (selectedpayslip.arrearSalary ?? 0)
        : 0;

    const totalDeductions = selectedpayslip
        ? (selectedpayslip.ptax ?? 0)
        + (selectedpayslip.TDS ?? 0)
        + (selectedpayslip.adjustmentPaid ?? 0)
        + (selectedpayslip.deductions ?? 0)
        : 0;



    const onSelect = (e) => {
        if (e.files && e.files.length > 0) {
            setSelectedFile(e.files[0]);
            setFileName(e.files[0].name);
        }
    };

    const onUpload = async () => {
        if (!selectedFile || !date) {
            alert("Please select a file and month/year");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);

        // Extract month/year from calendar value
        const jsDate = new Date(date);
        const selectedMonth = jsDate.toLocaleString("default", { month: "long" });
        const selectedYear = jsDate.getFullYear();

        formData.append("month", selectedMonth);
        formData.append("year", selectedYear);
        formData.append("user_id", userId);

        try {
            setLoading(true);
            await axios.post(
                `${config.apiBASEURL}/Salary_Generation_Routes/upload-salary-excel`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            alert("Excel uploaded successfully!");
            setVisible(false);
            setSelectedFile(null);
            setFileName(null);
            setDate(null); // reset calendar
        } catch (err) {
            console.error("Upload failed:", err);
            alert("Upload failed. Check console for details.");
        } finally {
            setLoading(false);
        }
    };


    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");
    const [debouncedSearch] = useDebounce(globalFilter, 500); // wait 500ms
    // Get current date
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = String(today.getMonth() + 1).padStart(2, "0"); // "01".."12"

    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);

    const [visible1, setVisible1] = useState(false);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [loading, setLoading] = useState(false);
    const monthsdownload = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];


    // Dropdown data
    const years = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i);

    const months = [
        { label: "January", value: "01" },
        { label: "February", value: "02" },
        { label: "March", value: "03" },
        { label: "April", value: "04" },
        { label: "May", value: "05" },
        { label: "June", value: "06" },
        { label: "July", value: "07" },
        { label: "August", value: "08" },
        { label: "September", value: "09" },
        { label: "October", value: "10" },
        { label: "November", value: "11" },
        { label: "December", value: "12" }
    ];


    const handleDownload = async () => {
        try {
            setLoading(true);
            const response = await axios.post(
                `${config.apiBASEURL}/Salary_Generation_Routes/generate-salary-excel`,
                { user_id: userId, month, year },
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    responseType: "blob", // 👈 now it works
                }
            );


            // Create a blob link to download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Salary_Report.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            setVisible1(false);
        } catch (err) {
            console.error("Download failed:", err);
        } finally {
            setLoading(false);
        }
    };


    // Employee data
    const [employees, setEmployees] = useState([]);


    const fetchSlips = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${config.apiBASEURL}/Salary_Generation_Routes/fetchall-monthly-slips`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    params: {
                        month: selectedMonth,
                        year: selectedYear,
                        search: debouncedSearch || ""
                    }
                }
            );

            // Transform API response into table data
            const mapped = response.data.flatMap((slip) =>
                slip.MonthlySlips.map((m) => ({
                    slNo: m.Msl_id,
                    name: m.Emp_name,
                    profile_image: m.Employee?.profileImage?.image_url || null, // <-- safe
                    createdby: slip.GeneratedBy
                        ? `${slip.GeneratedBy.first_name} ${slip.GeneratedBy.last_name}`
                        : "N/A",
                    designation: m.Designation,
                    month: m.Month,
                    year: m.Year,
                    doj: m.date_of_joining,
                    totalWorkingDays: m.total_days,
                    paidLeaveMonth: m.paid_leave,
                    noOfLate: m.late_count,
                    lateDays: m.late_days,
                    daysOffFull: m.days_off_full,
                    daysOffHalf: m.days_off_half,
                    absentDays: m.Absent_days,
                    paidLeaveUsed: m.Paid_leave_used,
                    balancePaidLeave: "-", // if you calculate this later
                    netOffDay: m.no_of_net_off_day,
                    adjustmentLeave: m.Adjustment_leave,
                    salaryDays: m.no_of_days_for_Salary,
                    extraWorkingDays: m.Extra_Working_days,
                    grossSalary: m.Gross_Salary,
                    salary: m.Salary,
                    arrearSalary: m.Arrear_Salary,
                    totalSalary: m.Total_Salary,
                    overtime: m.Overtime,
                    salaryWithOT: m.Total_including_overtime,
                    ptax: m.P_Tax,
                    deductions: m.Deductions,
                    salaryPayable: m.Salary_Payable,
                    adjustmentPaid: m.Adjustment,
                    netPayable: m.Net_Payable,
                    status: m.Status,
                    remarks: m.Remarks,
                    Payment_Status: m.Payment_Status,
                    Employee_code:m.Employee?.userDetails?.employee_id,
                }))
            );

            setEmployees(mapped);
        } catch (err) {
            console.error("❌ Failed to fetch salary slips:", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchSlips();
    }, [selectedMonth, selectedYear, debouncedSearch, accessToken]);





    const statusTemplate = (rowData) => {
        return (
            <span
                className={`badge ${rowData.status === "Send" ? "bg-success" : "bg-warning"
                    }`}
            >
                {rowData.status}
            </span>
        );
    };

    const nameTemplate = (rowData) => {
        return (
            <div className="d-flex align-items-center gap-2">
                <img
                    src={rowData.profile_image || noUserImg}
                    alt={rowData.name}
                    className="rounded-full"
                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "50%" }}
                />
                <div style={{ width: "calc(100% - 40px)" }}>
                    <span>{rowData.name}</span>
                    <small className='d-block'>
                        <span>generated by: {rowData.createdby}</span>
                        <Badge className='bg-success'>{rowData.status}</Badge>
                    </small>
                </div>

            </div>
        );
    };

    // Action buttons
    const actionTemplate = (rowData) => {
        return (
            <div className="flex gap-2">

                {rowData.status === "Generated" && (
                    <Button
                        icon="pi pi-pencil"
                        severity="warning"
                        rounded
                        text
                        tooltip="Edit"
                        tooltipOptions={{position:'top'}}
                        onClick={() => onedit(rowData)}
                    />
                )}
                <Button icon="pi pi-eye" severity="help" tooltipOptions={{position:'top'}} rounded text tooltip="View" onClick={() => onview(rowData)} />
                {/* <Button icon="pi pi-envelope" severity="success" rounded text tooltip="Send" /> */}
                {(rowData.status === "Sent" || rowData.status === "Cancelled") && (
                    <Button
                        icon="pi pi-file-pdf"
                        severity="secondary"
                        rounded
                        text
                        tooltip="Download"
                        tooltipOptions={{position:'top'}}
                        onClick={() => onGeneratepdf(rowData.slNo)}
                    />
                )}
                <Button icon="pi pi-clone" severity="info" rounded text tooltip="Duplicate" tooltipOptions={{position:'top'}} onClick={() => onduplicate(rowData.slNo)} />

                <Button icon="pi pi-trash" severity="danger" rounded text tooltip="Delete" tooltipOptions={{position:'top'}} onClick={() => ondelete(rowData.slNo)} />
            </div>
        );
    };

    const [slipIds, setSlipIds] = useState([]);


    const onstatuschange = () => {
        setSlipIds(selectedEmployees); // store full employee objects
        setVisiblesend(true);
    };




    const onview = (rowData) => {
        setVisibleRight(true);
        setSelectedpayslip(rowData);
    }

    const onedit = (rowData) => {
        setEditslip(rowData);
        setVisibleedit(true);

    }

    const onduplicate = async (slNo) => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${config.apiBASEURL}/Salary_Generation_Routes/monthly-slip/${slNo}/duplicate`,
                {},
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            if (response.status === 200) {
                fetchSlips();
            }
        } catch (error) {
            console.error("❌ Duplicate failed:", error);
        }
    };

    const ondelete = async (slNo) => {
        setLoading(true);
        try {
            const response = await axios.delete(`${config.apiBASEURL}/Salary_Generation_Routes/monthly-slip/${slNo}`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (response.status === 200) {
                fetchSlips();
            }
        } catch (error) {
            console.error("❌ Delete failed:", error);
            fetchSlips();
        }
    };

    const onGeneratepdf = async (slNo) => {
        setLoading(true);
        try {
            const response = await axios.post(`${config.apiBASEURL}/Salary_Generation_Routes/monthly-slips-pdf/${slNo}/pdf`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (response.status === 200) {
                // Refresh slips table
                await fetchSlips();

                // Optionally open the PDF in new tab
                if (response.data.pdfUrl) {
                    window.open(response.data.pdfUrl, "_blank");
                }
            }
        } catch (error) {
            console.error("❌ Delete failed:", error);
            fetchSlips();

        }
    };

    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }
    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col md={6} lg={6} className="mb-4">
                        <Breadcrumb>
                            <Breadcrumb.Item active>
                                Employee Salary List
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col md={6} lg={6} className="text-end mb-4">
                        <Button
                            label="Upload CSV"
                            icon="pi pi-file-excel"
                            className="py-2"
                            severity='help'
                            outlined
                            onClick={() => setVisible(true)}
                        />
                        <Button
                            label="Download CSV"
                            icon="pi pi-file-excel"
                            className="py-2 ms-2"
                            severity='success'
                            outlined
                            onClick={() => setVisible1(true)}
                        />
                        <Button
                            label="Bulk Confirm"
                            icon="pi pi-envelope"
                            className="py-2 ms-2"
                            severity='primary'
                            onClick={() => onstatuschange(true)}
                        />

                    </Col>
                    <Col lg={12}>
                        <Card>
                            <Card.Header>
                                <div className="d-flex justify-content-end gap-2">
                                    <div className="d-flex gap-2">
                                        <Dropdown
                                            value={selectedYear}
                                            options={years.map((y) => ({ label: y, value: y }))}
                                            onChange={(e) => setSelectedYear(e.value)}
                                            placeholder="Select Year"
                                            className="w-100"
                                        />
                                        <Dropdown
                                            value={selectedMonth}
                                            options={months}
                                            onChange={(e) => setSelectedMonth(e.value)}
                                            placeholder="Select Month"
                                            className="w-100"
                                        />
                                    </div>
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-search ps-2" />
                                        <InputText
                                            value={globalFilter}
                                            onChange={(e) => setGlobalFilter(e.target.value)}
                                            placeholder="Search"
                                            className="ps-4"
                                        />
                                    </span>
                                </div>

                            </Card.Header>
                            <DataTable
                                value={employees}
                                selection={selectedEmployees}
                                onSelectionChange={(e) => setSelectedEmployees(e.value)}
                                dataKey="slNo"
                                scrollable
                                className="payslip_employee_DT"
                            >
                                {/* Select All */}
                                <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} frozen />
                                {/* Frozen Columns */}
                                {/* <Column field="slNo" header="Sl No." frozen style={{ minWidth: "80px" }} /> */}
                                <Column
                                    field="name"
                                    header="Name of Employees"
                                    body={nameTemplate}
                                    frozen
                                    style={{ minWidth: "300px" }}
                                />

                                {/* Scrollable Columns */}
                                <Column field="designation" header="Designation" style={{ minWidth: "180px" }} />
                                <Column field="doj" header="Date of Joining" style={{ minWidth: "160px" }} className='table-info' />
                                <Column field="totalWorkingDays" header="Total Working Days" style={{ minWidth: "180px" }} />
                                <Column field="paidLeaveMonth" header="Paid leave for this month" style={{ minWidth: "220px" }} />
                                <Column field="noOfLate" header="No.of late" style={{ minWidth: "140px" }} />
                                <Column field="lateDays" header="Late days" style={{ minWidth: "140px" }} />
                                <Column field="daysOffFull" header="Days taken off (Full)" style={{ minWidth: "200px" }} />
                                <Column field="daysOffHalf" header="Days taken off (Half)" style={{ minWidth: "200px" }} />
                                <Column field="absentDays" header="Absent Days" style={{ minWidth: "160px" }} />
                                <Column field="paidLeaveUsed" header="No of paid leave used" style={{ minWidth: "200px" }} />
                                <Column field="balancePaidLeave" header="Balance Paid Leave" style={{ minWidth: "200px" }} />
                                <Column field="netOffDay" header="No.of net off day" style={{ minWidth: "200px" }} />
                                <Column field="adjustmentLeave" header="Adjustment if any- Leave allowed" style={{ minWidth: "300px" }} />
                                <Column field="salaryDays" header="No. of days for Salary" style={{ minWidth: "220px" }} />
                                <Column field="extraWorkingDays" header="Extra working Days" style={{ minWidth: "200px" }} />
                                <Column field="grossSalary" header="Gross Salary" style={{ minWidth: "180px" }} />
                                <Column field="salary" header="Salary" style={{ minWidth: "160px" }} />
                                <Column field="arrearSalary" header="Arrear Salary" style={{ minWidth: "200px" }} />
                                <Column field="totalSalary" header="Total Salary" style={{ minWidth: "200px" }} />
                                <Column field="overtime" header="Overtime" style={{ minWidth: "160px" }} />
                                <Column field="salaryWithOT" header="Total Salary including Overtime" style={{ minWidth: "300px" }} />
                                <Column field="ptax" header="P.Tax" style={{ minWidth: "140px" }} />
                                <Column field="deductions" header="Deductions" style={{ minWidth: "180px" }} />
                                <Column field="salaryPayable" header="Salary Payable" style={{ minWidth: "200px" }} />
                                <Column field="adjustmentPaid" header="Adjustment (adv. Paid)" style={{ minWidth: "250px" }} />
                                <Column field="netPayable" header="Net Payable" style={{ minWidth: "200px" }} />

                                {/* <Column header="Status" body={statusTemplate} style={{ minWidth: "160px" }} /> */}
                                <Column field="remarks" header="Remarks" style={{ minWidth: "200px" }} />

                                {/* Actions Column */}
                                <Column
                                    header="Actions"
                                    body={actionTemplate}
                                    style={{ minWidth: "160px" }}
                                    frozen
                                    alignFrozen="right"
                                />
                            </DataTable>
                        </Card>
                    </Col>

                    <Dialog
                        header="Upload Excel"
                        visible={visible}
                        style={{ width: '430px' }}
                        onHide={() => { if (!visible) return; setVisible(false); }}
                    >
                        <div>
                            <label>
                                Select Year & Month <sup className='text-danger'><b>*</b></sup>
                            </label>
                            <Calendar
                                value={date}
                                onChange={(e) => setDate(e.value)}
                                view="month"
                                dateFormat="mm/yy"
                                className='mt-2'
                                required
                                showIcon
                                placeholder="Select Year & Month"
                            />

                            <div className="mt-2">
                                <FileUpload
                                    mode="basic"
                                    name="file"
                                    accept=".xlsx,.xls"
                                    maxFileSize={5000000}
                                    auto={false}
                                    customUpload
                                    onSelect={onSelect}        // 👈 hook file selection
                                    uploadHandler={onUpload}   // not used here, we’ll trigger manually
                                    chooseLabel="Select Excel File"
                                />

                                {fileName && (
                                    <p className="mt-2" style={{ fontSize: '13px' }}>
                                        <b>Selected File:</b> {fileName}
                                    </p>
                                )}
                            </div>

                            <div className='d-flex justify-content-between align-items-center mt-3 border-top pt-3'>
                                <div className='d-flex align-items-center gap-2'>
                                    <Avatar label="S" style={{ backgroundColor: '#9c27b0', color: '#ffffff' }} />
                                    <small style={{ fontSize: '13px' }}>
                                        <b>Susie Willis</b>
                                        <small className='d-block'>Admin | Today 12:30 PM</small>
                                    </small>
                                </div>
                                <Button
                                    label="Upload"
                                    icon="pi pi-upload"
                                    className="py-2 ms-2"
                                    severity="success"
                                    onClick={onUpload}
                                    disabled={!selectedFile || !date} // 👈 only enable if both chosen
                                />
                            </div>
                        </div>
                    </Dialog>

                </Row>
            </Row>

            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '800px' }} className='paySlside'>
                <Table bordered size="sm" className="sl-table">
                    <thead>
                        <tr style={{border: '0'}}>
                            <td colspan="3" style={{padding: '10px', width: '360px', border: '0'}}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <img 
                                        src="https://ik.imagekit.io/blackboxv2/header/header_logo_1_Nm7IPGhVL" 
                                        alt="Company Logo" 
                                        style={{height: '170px', width: '170px', objectfit: 'contain'}}
                                    />

                                    <div style={{width: 'calc(100% - 120px)', marginLeft: '30px'}}>
                                        <h2 style={{margin: '0 0 0 0', fontSize: '16px', fontWeight:'600', color: '#191919', textTransform: 'uppercase'}}>
                                            {selectedpayslip?.name}
                                        </h2>

                                        <p style={{margin: '0 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919'}}>
                                            {selectedpayslip?.designation}
                                        </p>
                                        <p style={{margin: '8px 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919'}}>
                                            Employment No : <strong>{selectedpayslip?.Employee_code}</strong>
                                        </p>

                                        <p style={{margin: '0 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919'}}>
                                            Date of joining : <strong>{selectedpayslip?.doj}</strong>
                                        </p>

                                        <p style={{margin: '0 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919'}}>
                                            Earnings for : <strong>{selectedpayslip?.month}/{selectedpayslip?.year}</strong>
                                        </p>
                                        <p style={{margin: '0 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919'}}>
                                            No. of Days in this month : <strong>{selectedpayslip?.totalWorkingDays}</strong>
                                        </p>
                                    </div>
                                </div>
                            </td>

                            <td colspan="2" style={{padding: '22px 10px 10px 10px', textAlign: 'right', verticalAlign: 'top', width: '280px', paddingLeft: '65px', border: '0'}}>
                                <h3 style={{margin: '5px 0 10px 0', fontSize: '21px', color: '#000', fontWeight: 'bold'}}>
                                    SALARY PAY SLIP
                                </h3>
                                <p style={{margin: '0 0 6px 0', fontSize: '13px', color: '#858585'}}>
                                    Payslip For the Month <strong style={{display: 'block', fontSize: '13px', color: '#191919'}}>{selectedpayslip?.month}/{selectedpayslip?.year}</strong>
                                </p>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ background: '#cfcfcf' }}>
                            <th colSpan={3}>EARNINGS</th>
                            <th colSpan={2}>DEDUCTIONS</th>
                        </tr>
                        <tr>
                            <td width={'40%'}>
                                <small>SALARY HEAD </small>
                                <div>
                                    <span><b>Basic (Gross)</b></span>
                                    <span>Absents </span>
                                    <span>Half Days</span>
                                    <span>No.of lates</span>
                                    <span>Lates Deduction</span>
                                    <span>Total Leaves </span>
                                    <span>Leave Allowed(Adj) </span>
                                    <span>Paid Leave </span>
                                    <span><b>Deduction</b></span>
                                    <span><b>Overtime</b></span>
                                    <span><b>Arrears</b></span>
                                    <strong>SALARY PAID</strong>
                                </div>
                            </td>
                            <td width={'10%'}>
                                <small>Days</small>
                                <div>
                                    <span></span>
                                    <span>{selectedpayslip?.daysOffFull}</span>
                                    <span>{selectedpayslip?.daysOffHalf}</span>
                                    <span>{selectedpayslip?.noOfLate}</span>
                                    <span>{selectedpayslip?.lateDays}</span>
                                    <span>{selectedpayslip?.absentDays}</span>
                                    <span>{selectedpayslip?.adjustmentLeave}</span>
                                    <span>{selectedpayslip?.paidLeaveUsed}</span>
                                    <span><b>{lossOfPayDays}</b></span>
                                    <span><b>{selectedpayslip?.extraWorkingDays}</b></span>
                                    <span><b>{selectedpayslip?.arrearSalary}</b></span>
                                    <strong>{selectedpayslip?.salaryDays}</strong>
                                </div>

                            </td>
                            <td width={'15%'}>
                                <small>AMT. (Rs.)</small>
                                <div>
                                    <span><b>{selectedpayslip?.grossSalary}</b></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span><b>{leaveDeduction}</b></span>
                                    <span><b>{selectedpayslip?.overtime}</b></span>
                                    <span><b>{selectedpayslip?.arrearSalary}</b></span>
                                    <strong>{selectedpayslip?.salaryWithOT}/-</strong>
                                </div>
                            </td>
                            <td width={'15%'}>
                                <small>SALARY HEAD</small>
                                <div>
                                    <span>PF </span>
                                    <span>ESI</span>
                                    <span>P TAX </span>
                                    <span>TDS</span>
                                    <span>Advance</span>
                                    <span>Penalty</span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <strong>Total Deductions</strong>
                                </div>
                            </td>
                            <td width={'15%'}>
                                <small>AMT. (Rs.)</small>
                                <div>
                                    <span>0 </span>
                                    <span>0</span>
                                    <span>{selectedpayslip?.ptax}/- </span>
                                    <span>{selectedpayslip?.TDS} </span>
                                    <span>{selectedpayslip?.adjustmentPaid}</span>
                                    <span>{selectedpayslip?.deductions}</span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <strong>{totalDeductions}</strong>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr style={{ background: '#ececec' }}>
                            <th colSpan={3}>Pay - in - Hand</th>
                            <th colSpan={2}>{selectedpayslip?.netPayable}/-</th>
                        </tr>
                        <tr>
                            <td colSpan={1}><span>In Words : </span></td>
                            <td colSpan={4}>
                                <small>
                                    {selectedpayslip?.netPayable != null && !isNaN(selectedpayslip?.netPayable)
                                        ? `${toWords(Number(selectedpayslip.netPayable))
                                            .replace(/-/g, " ")
                                            .toUpperCase()} ONLY.`
                                        : "N/A"}
                                </small>
                            </td>

                        </tr>
                        <tr>
                            <th colSpan={3} className="text-end"><span><img src={stampImage} alt="brand-logo" className="" /></span></th>
                            <td colSpan={2} className="signature">
                                <span></span>
                                <small>Authorized Signatory</small>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={5} className="text-center">
                                <small className="d-block">193/1 MAHATAMA GANDI ROAD, KOLKATA - 700007</small>
                                <small>Email: <a href="mailto:Saurabh@thegraphe.com" className="text-primary">Saurabh@thegraphe.com</a></small>
                            </td>
                        </tr>
                    </tfoot>
                </Table>
            </Sidebar>

            <Sidebar visible={visibleedit} position="right" onHide={() => setVisibleedit(false)} style={{ width: '460px' }} className='paySlside'>
                <EditSalarySlip editslip={editslip} onclose={() => {
                    setVisibleedit(false);
                    fetchSlips();   // refresh slips after closing
                }} />
            </Sidebar>

            <Sidebar visible={visiblesend} position="right" onHide={() => setVisiblesend(false)} style={{ width: '860px' }} className='paySlside'>
                <SalaryStatus
                    slipIds={slipIds}
                    onclose={() => {
                        setVisiblesend(false);
                        fetchSlips();   // refresh slips after closing
                    }} />

            </Sidebar>




            <Dialog
                header="Download Employee List"
                visible={visible1}
                style={{ width: "400px" }}
                modal
                onHide={() => setVisible1(false)}

            >
                <div className="d-flex gap-3">
                    <div className="flex flex-column">
                        <label>Month</label>
                        <Dropdown
                            value={month}
                            options={monthsdownload}
                            onChange={(e) => setMonth(e.value)}
                            placeholder="Select Month"
                        />
                    </div>
                    <div className="flex flex-column">
                        <label>Year</label>
                        <InputText
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                            placeholder="Enter Year"
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-4">
                    <Button
                        label="Download"
                        icon="pi pi-file-excel"
                        className="py-2"
                        severity="success"
                        loading={loading}
                        onClick={handleDownload}
                        disabled={!month || !year}
                    />
                </div>
            </Dialog>
        </>
    );
};

export default Employee_salary_list;